/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useSearchSidebarContext } from "@project/contexts/SearchSidebarContext";
import './SubscriptionFilter.scss';
import { subscriptionSidemenuItem } from '@project/helpers/constants';
import HexIcon, { ColorTheme } from '../../../components/CustomIcons/HexIcon/HexIcon';
function SubscriptionFilter() {
  const location = useLocation();
  const { showSearchBar } = useSearchSidebarContext();
  const [collapsibleMenus, setCollapsibleMenus] = useState<any[]>([]);
  const [selectedSubMenu, setSelectedSubMenu] = useState('subscription/invoices');
  const [showSubMenu, setShowSubMenu] = useState(true);

  useEffect(() => {
    //check if the current URL is a collapsible menu or under a collapsible menu
    const pathname = location.pathname.replace('/', '');
    const collapsible = collapsibleMenus.find(
      (m: any) =>
        m.urlPath === pathname ||
        m.submenu?.find((x: any) => x.urlPath === pathname || x.chainUrls?.some((item: any) => item === pathname))
    );

    let updatedMenus: any[];
    if (collapsible) {
      updatedMenus = collapsibleMenus.map((menu) =>
        menu.urlPath === pathname ||
          menu.submenu?.find((x: any) => x.urlPath === pathname || x.chainUrls?.some((item: any) => item === pathname))
          ? {
            ...collapsible,
            isCollapsed: true,
          }
          : {
            ...menu,
            isCollapsed: false,
          }
      );
    } else {
      updatedMenus = collapsibleMenus.map((menu) => {
        return {
          ...menu,
          isCollapsed: false,
        };
      });
    }

    setCollapsibleMenus(updatedMenus);
  }, [location.pathname, subscriptionSidemenuItem]);

  const getNestedMenu = (menu: any): JSX.Element | null => {
    const collapsible = collapsibleMenus.find((x: any) => x.displayName === menu.displayName);

    if (collapsible === undefined || collapsible === null || (collapsible && !collapsible.isCollapsed)) {
      //if not yet added, add it to the state
      if (collapsible === undefined || collapsible === null) {
        setCollapsibleMenus([...collapsibleMenus, menu]);
      }
      return null;
    }

    return (
      <li className="sub-menu flex flex-row">
        <div className="vertical-divider">
          <div />
        </div>
        <div className="w-100">
          <ul>
            {menu.submenu?.map((item: any, key: number) => (
              <li key={key}>
                <NavLink
                  to={item.urlPath}
                  className={({ isActive }) =>
                    `${item.color}-themed-box ` +
                    (isActive || item.chainUrls?.some((x: any) => x === location.pathname.replace('/', ''))
                      ? 'sidemenu-selected'
                      : '')
                  }
                  end
                >
                  <span>{item.displayName}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      </li>
    );
  };

  const getMenu = (): JSX.Element[] => {
    return subscriptionSidemenuItem[0].items.map((item, key) => {
      return (
        <React.Fragment key={key}>
          <li className="relative">
            <NavLink
              to={item.urlPath}
              onClick={() => {
                if (selectedSubMenu === item.urlPath) {
                  setShowSubMenu(!showSubMenu);
                } else {
                  setShowSubMenu(true);
                  setSelectedSubMenu(item.urlPath);
                }
              }}
              className={({ isActive }) =>
                `${item.color}-themed-box ${isActive || (item.submenu && item.submenu.length > 0) ? 'sidemenu-selected' : ''} ${!item.submenu || (item.submenu && item.submenu.length == 0)
                  ? isActive
                    ? 'non-collapsible-selected'
                    : ''
                  : 'has-submenu'
                }`
              }
              end
            >
              <>
                <HexIcon icon={item.icon} colorTheme={(item.color ?? 'green') as ColorTheme} colorMode="fill" />
                <span>{item.displayName}</span>

                {item.submenu && item.submenu.length > 0 ? (
                  selectedSubMenu === item.urlPath && showSubMenu ? (
                    <i className="icon icon-chevron-up collapse-menu-icon" />
                  ) : (
                    <i className="icon icon-chevron-down collapse-menu-icon" />
                  )
                ) : (
                  <></>
                )}
              </>
            </NavLink>
          </li>

          {selectedSubMenu === item.urlPath && showSubMenu &&
            item.submenu &&
            item.submenu.length > 0 && getNestedMenu(item)}
        </React.Fragment>
      );
    });
  };

  return (
    <aside className={`account-filter ${!showSearchBar ? 'filter-toggle' : ''}`}>
      <section className="menu-row">
        <ul className="flex flex-col">{getMenu()}</ul>
      </section>
    </aside>
  );
}

export default SubscriptionFilter;
